// src/app/billing-profile/state/billingProfile.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as BillingProfileActions from './billingProfile.actions';
import { BillingProfileService } from '../../services/billing-profile.service'; // Adjust path as needed

@Injectable()
export class BillingProfileEffects {
  constructor(private actions$: Actions, private billingProfileService: BillingProfileService) {}

  fetchBillingProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingProfileActions.fetchBillingProfile),
      switchMap(() =>
        this.billingProfileService.getBillingProfile().pipe(
          map(data => BillingProfileActions.fetchBillingProfileSuccess({ data })),
          catchError(error => of(BillingProfileActions.fetchBillingProfileFailure({ error })))
        )
      )
    )
  );

  updateBillingProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingProfileActions.updateBillingProfile),
      switchMap(({ id, billingProfile }) =>
        this.billingProfileService.updateBillingProfile(id, billingProfile).pipe(
          map(response => BillingProfileActions.updateBillingProfileSuccess({ billingProfile: response })),
          catchError(error => of(BillingProfileActions.updateBillingProfileFailure({ error })))
        )
      )
    )
  );

  submitBillingProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingProfileActions.submitBillingProfile),
      switchMap(({ billingProfile }) =>
        this.billingProfileService.submitBillingProfile(billingProfile).pipe(
          map(response => BillingProfileActions.submitBillingProfileSuccess({ billingProfile: response })),
          catchError(error => of(BillingProfileActions.submitBillingProfileFailure({ error })))
        )
      )
    )
  );

  deleteBillingProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BillingProfileActions.deleteBillingProfile),
      switchMap(action =>
        this.billingProfileService.deleteBillingProfile(action.id).pipe(
          map(() => BillingProfileActions.deleteBillingProfileSuccess({ id: action.id })),
          catchError(error => of(BillingProfileActions.deleteBillingProfileFailure({ error })))
        )
      )
    )
  );

}
